import cookies from "cookiesjs"

/**
 * Collection with matching and parsing data
 * for any kind of contract option
 * @type {Array}
 */
export const parsingData = [ {
  'match': (option) => option.mail_kept,
  'parse': (option, contract) => {
    const mailboxNumber = option.hasOwnProperty('mail_kept_mailbox_number')
      && option.mail_kept_mailbox_number
    return mailboxNumber ? `BAL ${mailboxNumber}` : ''
  }
}, /* {
  'match': (option, contract) => option.mail_forwarded,
  parser: (option, contract) => ``
}, */ {
  'match': (option) => option.custom_hotline,
  'parse': (option, contract) => option.hotline_phone
}, {
  'match': (option) => option.simple_hotline,
  'parse': (option, contract) => option.hotline_phone
} ]

export default {
  props: ["contract"],

  computed: {
    routerLink () {
      return {
        name: 'contract-management',
        params: { contractId: this.contract.id }
      }
    },

    agencyAddressLine () {
      const agency = this.contract.offer.distributed_product.agency

      return `${agency.street_line1} ${agency.zipcode} ${agency.city}`
    },

    completeButtonUrl() {
      return __CONTRACT_PURCHASE_TUNNEL_URL__ + '/select_contract?contract_id=' + this.contract.id + '&token=' + cookies('token')
    }
  },

  methods: {
    decodeOptionLine (contractOption) {
      const { option } = contractOption,
        ret = ""+option.name,
        additional = this.parseAdditionalOption(option)

      return _.isEmpty(additional)?
        ret : ret.concat(` (${additional})`)
    },

    parseAdditionalOption (option) {
      let ret = ""

      _.each(parsingData, ({ match, parse }) => {
        if (match(option)) {
          ret = parse(option, this.contract)
          return false
        }
      })

      return ret
    },
  }
}



// WEBPACK FOOTER //
// ./client/components/Customer/InformationsContent/Contracts/commonLogic.js